// Toast — недеструктивний попап-уведомлення внизу екрана.
// Зʼявляється з slide-up анімацією, автоматично зникає через duration ms.
// Використовуй для радісних підтверджень («Аванс видано!», «Виплачено!»,
// «Звіт збережено!») замість сумного window.alert.
//
// Usage:
//   const [toast, setToast] = useState<ToastMsg | null>(null);
//   ...
//   <Toast msg={toast} onClose={() => setToast(null)} />

import { useEffect, type ReactNode } from "react";

export interface ToastMsg {
  text: ReactNode;
  /** "gold" — для авансу, "green" — для виплат, "rose" — для дефолту. */
  tone?: "gold" | "green" | "rose";
  /** Мс. Default 3500. */
  duration?: number;
}

export function Toast({
  msg,
  onClose,
}: {
  msg: ToastMsg | null;
  onClose: () => void;
}) {
  useEffect(() => {
    if (!msg) return;
    const t = window.setTimeout(onClose, msg.duration ?? 3500);
    return () => window.clearTimeout(t);
  }, [msg, onClose]);

  if (!msg) return null;
  const tone = msg.tone ?? "rose";
  return (
    <div
      role="status"
      aria-live="polite"
      onClick={onClose}
      className={`nz-toast nz-toast-${tone}`}
    >
      {msg.text}
    </div>
  );
}
